import React, { useState, useEffect, useCallback } from 'react'
import Spiner from '../../components/General/Spiner'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import DynamicTable from '../../components/DataTables/DynamicTable'
import { useSnackbar } from 'notistack'
import Logs from '../../components/General/LogDetail'

const TableroDetailsAll = ({ dataFavRec }) => {
    const [spiner, setSpiner] = useState(false)
    const [data, setdata] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const { enqueueSnackbar } = useSnackbar()

    const getTableroXArea = useCallback(async (id, pege, perpage, search) => {
        setSpiner(true)
        const resp = await ConfiguracionLogic.tableroXAreasBiLogic(id, pege, perpage, search)
        if (resp.success && (!dataFavRec || dataFavRec.length === 0)) {
            setdata(resp.data)
            setTotalRows(resp.totalRows)
        }
        enqueueSnackbar(resp.message, {
            variant: resp.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        setSpiner(false)
    }, [enqueueSnackbar, dataFavRec])

    useEffect(() => {
        if (!dataFavRec || dataFavRec.length === 0) { 
            getTableroXArea(0, 1, 10)
        } else {
            setdata(dataFavRec.data || [])
            setTotalRows(dataFavRec.totalRows || 0)
        }
    }, [dataFavRec, getTableroXArea])

    const handleRedirectBack = () => {
        localStorage.removeItem('idAreaBI')
        localStorage.removeItem('nombreBI')
        localStorage.removeItem('descripcionBI')
        localStorage.removeItem('urlTableroBi')
        localStorage.setItem('returnBiDEtail', 2)
        window.location.href = global.TABLERO_LIST
    }

    const handleSearch = (item) => {
        getTableroXArea(0, 1, 50, item)
    }

    const handlePageChange = (page, perPage) => {
        getTableroXArea(0, page, perPage, '')
    }

    const columns = ['Nombre', 'Descripcion', 'Area']

    const handleWatch = async (item) => {
        localStorage.setItem('idTableoBI', item.id)
        localStorage.setItem('nombreBI', item.nombreTablero)
        localStorage.setItem('descripcionBI', item.Descripcion)
        localStorage.setItem('urlTableroBi', item.urlTablero)
        localStorage.setItem('pageOp', 2)
        Logs.logDetail(localStorage.getItem('secuenciaUsuario'), "click Dashboard id: " + item.id, 'vizualizar tablero: ' + item.nombreTablero, '/detalle-tableros', localStorage.getItem('codigoUsuario'))
        window.location.href = global.TABLERO_DETAILBI
    }

    const onFavorite = async (item) => {
        setSpiner(true)
        const resp = await ConfiguracionLogic.saveFavLogic(item)
        enqueueSnackbar(resp.message, {
            variant: resp.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        window.location.href = global.TABLERO_LIST
        setSpiner(false)
    }

    return (
        <div>
            <Spiner opt={spiner} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <br />
                                <div className="card-body">
                                    <DynamicTable
                                        columns={columns}
                                        data={data}
                                        onWatch={handleWatch}
                                        onSearch={handleSearch}
                                        onPageChange={handlePageChange}
                                        totalRows={totalRows}
                                        onFavorite={onFavorite}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default TableroDetailsAll
